import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ERoutes } from "ts/enums";

const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate(ERoutes.MAIN);
    }, 1500);
  }, []);

  return (
    <div id="error-page" className="tl-error">
      {/*<h1>{ t('Shared.Errors.GenericErrorTitle') }</h1>
      <p>{ t('Shared.Errors.GenericErrorDesc') }</p> */}
      <h5 className="m-4">Navigating you to main page... Please wait</h5>
    </div>
  );
}

export default ErrorPage;
